import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {ProfileContainer, OuterContainer} from "@irati/ui/src/Modal/components/styled"

import ProfilePicGroup from "../../../ProfilePicGroup"
import {LARGE_TROPHY_SIZE} from "../../../ProfilePicWithTrophy"

const ProfileNoBorder = styled.div`
  position: absolute;

  ${({size}) => `
    top: -${(size / 2) + 5}px;
    width: ${size}px;
    height: ${size}px;
  `}
`

const ModalHeader = ({children, size, users, trophy}) => {
  const singlePictureSize = 150
  const multiplePictureSize = 100

  return (
    <ProfileContainer size={size}>
      <OuterContainer size={size}>
        <ProfileNoBorder size={size}>
          <ProfilePicGroup
            users={users}
            trophy={trophy}
            trophySize={LARGE_TROPHY_SIZE}
            outerWrapperSize={size}
            innerWrapperSize={size}
            singlePictureSize={singlePictureSize}
            multiplePictureSize={multiplePictureSize}
            isExpanded>
            {children}
          </ProfilePicGroup> 
        </ProfileNoBorder>
      </OuterContainer>
    </ProfileContainer>
  )
}

ModalHeader.propTypes = {
  children: PropTypes.node,
  size: PropTypes.number.isRequired,
  users: PropTypes.array,
  trophy: PropTypes.object
}

ModalHeader.defaultProps = {
  children: null,
  trophy: null
}

export default ModalHeader
